import {
  Stack,
  Box,
  Tab,
  Tabs,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import { ReactComponent as IconDocument } from "../../../../images/iconFile.svg";

import "../styles.css";
import AccordionSummaryTitle from "../AccordionSummaryTitle";

import PrimeiraEtapa from "./ContentTabs/PrimeiraEtapa";
import SegundaEtapa from "./ContentTabs/SegundaEtapa";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-AnamneseNeurologica-${index}`}
      aria-labelledby={`simple-tab-AnamneseNeurologica-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "16px 0px" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-AnamneseNeurologica-${index}`,
    "aria-controls": `simple-tabpanel-AnamneseNeurologica-${index}`,
  };
}

const handleProgressForm = (data, showTabs = false) => {
  const fieldHide = "*";
  const fields = [
    data.ventilacaoNaoInvasivaBIPAP,
    data.ventilacaoNaoInvasivaBIPAP === "50" ? data.bipapDataInicio : fieldHide,
    data.ventilacaoNaoInvasivaBIPAP === "50" ? data.bipapDuracao : fieldHide,
    data.traquestomia,
    data.traquestomia === "50" ? data.traqueostomiaDataInicio : fieldHide,
    data.traquestomia === "50" ? data.traqueostomiaProcedimento : fieldHide,
    data.gastrostomia,
    data.gastrostomia === "50" ? data.gastrostomiaDataInicio : fieldHide,
    data.sondaNasogastrica,
    data.sondaNasogastrica === "50"
      ? data.sondaNasogastricaDataInicio
      : fieldHide,
    data.coughAssist,
    data.tecnologiaComunicacao,
    data.assistenciaDomiciliar,
    data.multidisciplinar,
    data.multidisciplinar === "50"
      ? data.multidisciplinarTipo[data.multidisciplinarTipo.length - 1] ?? ""
      : fieldHide,
    data.usoCadeiraDeRodas,
    data.usoCadeiraDeRodas === "50" ? data.tipoProcedimento : fieldHide,
    showTabs ? data.anamnese : fieldHide,
    showTabs
      ? data.sinaisSintomas[data.sinaisSintomas.length - 1] ?? ""
      : fieldHide,
  ];

  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
};

export default function AnamneseNeurologica({
  expanded,
  handleChangePanel,
  onSubmit,
  setData,
  data,
  ventilacaoNaoInvasivaDuracaoOptions,
  traqueostomiaProcedimentoOptions,
  handleCheckedField,
  multidisciplinaridadeTipoOptions,
  tipoProcedimentoOptions,
  simOuNaoOptions,
  showTabs = false,
  valueTab,
  onChangeTab,
  sinaisSintomasList,
  ...props
}) {
  const progressForm = handleProgressForm(data, showTabs);

  const RenderSegundaEtapa = () => (
    <SegundaEtapa
      handleChangePanel={handleChangePanel}
      onSubmit={onSubmit}
      setData={setData}
      data={data}
      ventilacaoNaoInvasivaDuracaoOptions={ventilacaoNaoInvasivaDuracaoOptions}
      traqueostomiaProcedimentoOptions={traqueostomiaProcedimentoOptions}
      handleCheckedField={handleCheckedField}
      multidisciplinaridadeTipoOptions={multidisciplinaridadeTipoOptions}
      tipoProcedimentoOptions={tipoProcedimentoOptions}
      simOuNaoOptions={simOuNaoOptions}
    />
  );

  return (
    <Accordion
      defaultExpanded={false}
      expanded={expanded === "anamneseNeurologica"}
      onChange={handleChangePanel("anamneseNeurologica")}
      className="AccordionContainer"
    >
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="anamneseNeurologica-content"
        id="anamneseNeurologica-header"
        className="AccordionSummaryContainer"
      >
        <AccordionSummaryTitle
          title="Anamnese neurológica"
          icon={<IconDocument style={{ width: "24px" }} />}
          progressForm={progressForm}
        />
      </AccordionSummary>
      <AccordionDetails>
        {showTabs ? (
          <>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                TabIndicatorProps={{
                  style: {
                    background: "#1E729F",
                  },
                }}
                sx={{
                  fontFamily: "Nunito",
                  fontWeight: 400,
                  ".Mui-selected": {
                    color: "#1E729F",
                    fontWeight: "700 !important",
                  },
                }}
                value={valueTab}
                onChange={onChangeTab}
                aria-label="basic tabs example"
              >
                <Tab
                  label="Primeira Etapa"
                  {...a11yProps(0)}
                  className="tabTitle"
                />
                <Tab
                  label="Segunda Etapa"
                  {...a11yProps(1)}
                  className="tabTitle"
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={valueTab} index={0}>
              <PrimeiraEtapa
                handleChangePanel={handleChangePanel}
                onSubmit={onSubmit}
                setData={setData}
                data={data}
                sinaisSintomasList={sinaisSintomasList}
              />
            </CustomTabPanel>
            <CustomTabPanel value={valueTab} index={1}>
              {RenderSegundaEtapa()}
            </CustomTabPanel>
          </>
        ) : (
          RenderSegundaEtapa()
        )}
      </AccordionDetails>
    </Accordion>
  );
}
